// Module
var code = `<template> <div class="chart-legend"> <div class="chart-legend-item row" repeat.for="item of data" click.delegate="clickItem(item, \$index)"> <i class="indicator" css="background: \${item.color}"></i> <span class="label">\${item | legendStringFormat:{format:format, params:params}}</span> </div> </div> </template>`;
// Exports
module.exports = code;